import { Dialog } from '@ui'
import { Button } from '@runeffective/evo-design-system'
import React from 'react'
import { IBooking, IEmployee } from '@api'
import { SHARED, isShared } from '@utils'

export const getWarningMessage = ({
  oldType,
  newType,
  employee,
  bookings,
}: {
  oldType: string | undefined
  newType: any
  employee: IEmployee | null | undefined
  bookings: IBooking[] | undefined
}) => {
  let message
  switch (oldType) {
    case 'primary_seat':
      if (employee && isShared(newType)) {
        return
      }

      message = employee
        ? `Assigning this seat to be ${
            newType?.displayName === 'Neighborhood'
              ? 'part of a Neighborhood'
              : `a ${newType?.displayName}`
          } will unassign ${employee} from their seat.`
        : `Assigning this seat to be ${
            newType?.displayName === 'Neighborhood'
              ? 'part of a Neighborhood'
              : `a ${newType?.displayName}`
          } will unassign any employee from their seat in all future assignment plans.`
      break
    case 'secondary_seat':
      message = employee
        ? `Assigning this seat to be ${
            newType?.displayName === 'Neighborhood'
              ? 'part of a Neighborhood'
              : `a ${newType?.displayName}`
          } will unassign ${employee} from their secondary seat.`
        : ''
      break
    case 'hoteling_desk':
      message = bookings?.length
        ? `This action will cancel all reservations on this Hoteling seat. Are you sure you want to make this seat a ${newType?.displayName}?`
        : `A seat that is a ${newType?.displayName} cannot be bookable. Are you sure you want to make this seat a ${newType?.displayName}?`
      break
    default:
  }
  return message
}

const UsageWarningDialog = ({
  usageAssign,
  setUsageAssign,
  assignUsageType,
  cancelAssignment,
  spaceDetails,
}: {
  usageAssign: boolean
  setUsageAssign: () => void
  assignUsageType: () => void
  cancelAssignment: () => void
  spaceDetails: {
    oldType: string | undefined
    newType: {
      value: string
    } | null
    employee: IEmployee | null | undefined
    bookings: IBooking[] | undefined
  }
}) => {
  return (
    <Dialog
      isOpen={usageAssign}
      transitionDuration={200}
      isCloseButtonShown={true}
      canOutsideClickClose={false}
      title={'Warning'}
      onClose={setUsageAssign}
      body={<div>{getWarningMessage(spaceDetails)}</div>}
      footer={
        <>
          <Button layout="danger" size="small" onClick={cancelAssignment}>
            Cancel
          </Button>
          <Button
            style={{ marginLeft: '10px' }}
            layout="primary"
            size="small"
            onClick={assignUsageType}
          >
            Assign
          </Button>
        </>
      }
    />
  )
}

export default UsageWarningDialog
